module.exports = __webpack_public_path__ + "static/media/Fontenay BTL.fdf41234.jpg";